export const PLENARY_STUDENT_COOKIE_NAME = 'plenary_student';
export const PLENARY_CODE_VERIFIED_COOKIE_NAME = 'plenary_code_verified';
